import { Outlet } from 'react-router'
import { Spinner } from '@/components/ui/spinner'
import { useMe } from '@/features/auth/queries/use-me'

/**
 * Resolves the Luminate session for the routes that need it, and holds the
 * screen until it has.
 *
 * This used to sit in `App`, where it ran on every route including Marquee:
 * one request to the vision-tool API, blocking the first paint of a section
 * that never reads its answer. It is a route now so that the Marquee tree can
 * be a sibling and resolve its own operator instead (`MarqueeSessionRoute`).
 *
 * The wait is not cosmetic. `RoleBasedRouteGuard` decides on `user.role`, and
 * without an answer it would bounce a legitimate reviewer to Welcome, so every
 * route that guards on a role has to sit under this.
 *
 * `useMe` is disabled without an access token, which leaves `isLoading` false,
 * so the login and other anonymous screens render straight away and no request
 * goes out for them.
 */
function LuminateSessionRoute() {
	const { isLoading } = useMe()

	if (isLoading) {
		return (
			<div className='flex h-full items-center justify-center'>
				<Spinner size={32} />
			</div>
		)
	}

	return <Outlet />
}

export { LuminateSessionRoute }
